import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { WorkspaceSidebarEffects } from './workspace-sidebar-effects';
import { workspaceSidebarFeature } from './workspace-sidebar-feature';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(workspaceSidebarFeature),
    EffectsModule.forFeature(WorkspaceSidebarEffects),
  ],
})
export class WorkspaceSidebarFeatureModule {}
